import BidButton from '../../elements/BidButton/BidButton'
import { useRouter } from 'next/router'

const LoginRedirect = () => {
  const router = useRouter()
  const loginRedirect = (e: any) => {
    e.stopPropagation()
    // Set sessionStorage item for post-login use
    router.push(`/account/login?returnUrl=${encodeURIComponent(router.asPath)}`)
  }
  return (
    <BidButton
      label="Log In To Bid"
      theme="blue-light"
      callBack={loginRedirect}
      width="full"
      size="lg"
    />
  )
}

export default LoginRedirect
